import { Trans, useTranslation } from "react-i18next";

import util from "utils/utils";

import type { NotificationContentProps, NotificationContextOf } from "../types";

const AnnouncementReport = ({
  context,
  ownerChallenge,
  ownerGroup,
}: NotificationContentProps & {
  context?: NotificationContextOf<"announcementReport">;
}) => {
  const { t } = useTranslation();

  let contextStr = "your";
  let contextName = "organisation";
  if (ownerChallenge) {
    contextStr = `the ${t("generic.challenge")}`;
    contextName = ownerChallenge.name ?? contextName;
  } else if (ownerGroup) {
    contextStr = `the ${t("generic.group")}`;
    contextName = ownerGroup.name ?? contextName;
  }

  const recipients =
    typeof context?.recipients === "number" ? context.recipients : 0;

  return (
    <Trans
      i18nKey="notifications.announcementReport"
      values={{
        announcement: context?.subject ?? "",
        contextStr,
        contextName,
        recipients: util.pluralise(recipients, "recipient", "recipients"),
      }}
    />
  );
};

export default AnnouncementReport;
